var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM8.03125 7C7.86719 7 7.75 7.12891 7.75 7.28125V7.46875C7.75 7.63281 7.86719 7.75 8.03125 7.75C8.03125 8.81641 8.62891 9.71875 9.4375 10C8.62891 10.293 8.03125 11.1953 8.03125 12.25C7.86719 12.25 7.75 12.3789 7.75 12.5312V12.7188C7.75 12.8828 7.86719 13 8.03125 13H11.9688C12.1211 13 12.25 12.8828 12.25 12.7188V12.5312C12.25 12.3789 12.1211 12.25 11.9688 12.25C11.9688 11.1953 11.3594 10.293 10.5508 10C11.3594 9.71875 11.9688 8.81641 11.9688 7.75C12.1211 7.75 12.25 7.63281 12.25 7.46875V7.28125C12.25 7.12891 12.1211 7 11.9688 7H8.03125Z",
    fill: "#DC7D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassO);
export default __webpack_public_path__ + "static/media/hourglass-o.9e2652fb6f26fe79fb325080816c3a25.svg";
export { ForwardRef as ReactComponent };